import { validateDoseScale } from './doseFactor';

// Every voxel of the original dose times the factor: a new factor replaces the old one, never compounds it.
export function scaledDoseGy(
    originalGy: Float32Array,
    factor: number
): Float32Array {
    validateDoseScale(factor);
    const scaled = new Float32Array(originalGy.length);
    for (let i = 0; i < originalGy.length; i++) {
        scaled[i] = originalGy[i] * factor;
    }
    return scaled;
}
